import { newTrigramsMap } from '~/maps/newTrigramsMap';
import { humanReadableValueFromMap } from '~common-helpers/index';

export function newTrigramTypePipe(value: string) {
    return humanReadableValueFromMap(newTrigramsMap, value);
}
